var _style, _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPediatricAllergist = function SvgPediatricAllergist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108 108",
    style: {
      enableBackground: "new 0 0 108 108"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9F9FA;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#02FFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Monique"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pediatric_Allergist"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55,91.2c-3.1,0.2-5.7-2.1-5.9-5.2c0-0.2,0-0.4,0-0.6c0-2.1,3.5-9.8,4.6-12.2c0.3-0.8,1.2-1.1,2-0.7 c0.3,0.1,0.6,0.4,0.7,0.7c1.1,2.3,4.6,10.1,4.6,12.2c0.1,3.1-2.2,5.7-5.3,5.8C55.5,91.2,55.3,91.2,55,91.2z M55,77.5 c-1.6,3.6-2.9,7.1-2.9,7.9c0,1.3,0.5,2.8,2.9,2.8s3-1.5,3-2.8C58,84.6,56.6,81.1,55,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.1,84.9c-0.6,0-1.2-0.1-1.8-0.3c-2.6-0.6-4.3-3.2-3.8-5.8c0-0.2,0.1-0.4,0.1-0.5c0.5-1.7,4.8-6.8,6.6-8.8 c0.4-0.4,1-0.6,1.5-0.4c0.6,0.1,1,0.6,1.1,1.2c0.4,2.7,1.3,9.3,0.9,11c-0.3,1.2-1,2.2-2,2.9C44.1,84.6,43.1,84.9,42.1,84.9z  M43.5,74c-1.4,1.6-2.7,3.3-3.8,5.2c-0.4,1,0.1,2.1,1,2.5c0.2,0.1,0.3,0.1,0.5,0.1c0.6,0.2,1.3,0.2,1.9-0.1 c0.4-0.3,0.7-0.8,0.8-1.3C44,78.2,43.8,76.1,43.5,74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.7,85.7c-0.8,0-1.5-0.2-2.2-0.6c-1.1-0.6-1.9-1.6-2.4-2.8c-0.8-1.7-1-9.3-1-11.6c0-0.6,0.3-1.2,0.9-1.4 c0.6-0.2,1.2-0.1,1.6,0.3c1.7,1.6,7.2,6.8,7.9,8.5c1.1,2.4,0.7,5.6-2.5,7C70.2,85.5,69.5,85.7,68.7,85.7z M66.1,74.4 c0,2.3,0.2,4.5,0.7,6.8c0.2,0.6,0.6,1,1.1,1.3c0.6,0.3,1.3,0.3,1.8-0.1c1.3-0.6,1.7-1.6,1-3C69.3,77.7,67.8,76,66.1,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39,66.5c-1.2,0-2.4-0.2-3.6-0.6c-4.7-1.7-5.7-7.4-5-11c0.4-1.8,2.2-5.3,4.4-9.4c1.7-3.2,3.4-6.4,4.5-9 c2.4-5.5,2.7-18.1,2.7-18.2c0-0.8,0.7-1.5,1.5-1.5l0,0c0.8,0,1.5,0.7,1.5,1.5c0,0,0,0,0,0c0,0.5-0.3,13.2-2.9,19.3 c-1.2,2.7-2.9,6-4.6,9.2c-1.9,3.6-3.8,7.3-4.1,8.7c-0.5,2.1,0,6.4,3,7.5c3.4,1.2,6.4-0.2,7.4-1.6c0.5-0.7,1.4-0.8,2.1-0.3 c0.7,0.5,0.8,1.4,0.3,2.1C44.5,65.4,41.8,66.6,39,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,65.3c-2.5,0-4.1-1.7-5.7-3.4L48,61.6c-1.7-1.9-3.2-3-5-3c-1.4,0-2.9,2.2-3.2,2.7c-0.4,0.7-1.3,1-2,0.6 c-0.7-0.4-1-1.3-0.6-2l0,0c0.2-0.4,2.4-4.3,5.9-4.3s5.9,2.6,7.2,4l0.3,0.3c1.5,1.6,2.3,2.4,3.5,2.4c0.8,0,1.5,0.7,1.5,1.5 C55.5,64.7,54.8,65.3,54,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69,66.5c-2.8,0.1-5.5-1.1-7.3-3.3c-0.5-0.7-0.4-1.6,0.3-2.1c0.7-0.5,1.6-0.4,2.1,0.3l0,0 c1,1.4,4,2.8,7.4,1.6c3.1-1.1,3.5-5.4,3-7.5c-0.3-1.4-2.2-5.1-4.1-8.7c-1.7-3.2-3.4-6.5-4.6-9.2C63.3,31.5,63,18.9,63,18.3 c0-0.8,0.6-1.5,1.5-1.5c0,0,0,0,0,0l0,0c0.8,0,1.5,0.6,1.5,1.5c0,0,0,0,0,0c0,0.1,0.3,12.6,2.6,18.2c1.1,2.6,2.8,5.8,4.5,9 c2.2,4.1,4,7.6,4.4,9.4c0.8,3.6-0.3,9.3-5,11C71.4,66.3,70.2,66.5,69,66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,65.3c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5c1.2,0,2-0.8,3.5-2.5l0.3-0.3c1.3-1.4,3.7-4,7.2-4 c3.5,0,5.6,3.8,5.9,4.3c0.4,0.7,0.1,1.6-0.6,2c-0.7,0.4-1.6,0.1-2-0.6c-0.4-0.7-1.8-2.7-3.2-2.7c-1.9,0-3.3,1.2-5,3l-0.3,0.3 C58.1,63.7,56.5,65.3,54,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.1,48.2c-0.5,0-1-0.2-1.2-0.7L55,41.9c-0.5-0.7-0.3-1.6,0.4-2.1c0.7-0.5,1.6-0.3,2.1,0.4l3.8,5.7 c0.5,0.7,0.3,1.6-0.4,2.1c0,0,0,0,0,0C60.7,48.2,60.4,48.3,60.1,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.6,45.4h-6.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h6.9c0.8,0,1.5,0.7,1.5,1.5S62.4,45.4,61.6,45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.3,48.3c-0.3,0-0.6-0.1-0.8-0.2c-0.7-0.4-0.9-1.3-0.4-2l3.8-5.8c0.5-0.7,1.4-0.9,2.1-0.4 c0.7,0.5,0.9,1.4,0.4,2.1l-3.8,5.7C57.2,48,56.8,48.3,56.3,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,33.1c-0.5,0-1-0.3-1.2-0.7l-4.8-7c-0.5-0.7-0.3-1.6,0.4-2.1c0.7-0.5,1.6-0.3,2.1,0.4l0,0l4.7,7 c0.5,0.7,0.3,1.6-0.4,2.1c0,0,0,0,0,0C55.5,33,55.2,33.1,54.9,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.8,29.5h-8.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h8.5c0.8,0,1.5,0.7,1.5,1.5S57.6,29.5,56.8,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.2,33.1c-0.8,0-1.5-0.7-1.5-1.5c0-0.3,0.1-0.6,0.3-0.8l4.7-7.1c0.5-0.7,1.4-0.9,2.1-0.4 c0.7,0.5,0.9,1.4,0.4,2.1l-4.7,7.1C51.2,32.8,50.7,33.1,50.2,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.7,38.3c-0.5,0-1-0.3-1.2-0.7l-4.8-7c-0.5-0.7-0.3-1.6,0.4-2.1c0.7-0.5,1.6-0.3,2.1,0.4L80,36 c0.5,0.7,0.3,1.6-0.4,2.1c0,0,0,0,0,0C79.3,38.2,79,38.3,78.7,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.6,34.8h-8.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h8.5c0.8,0,1.5,0.7,1.5,1.5S81.4,34.8,80.6,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74,38.3c-0.3,0-0.6-0.1-0.8-0.2c-0.7-0.5-0.9-1.4-0.4-2.1l4.7-7.1c0.4-0.7,1.4-0.9,2.1-0.4c0,0,0,0,0,0 c0.7,0.5,0.9,1.4,0.4,2.1l-4.7,7.1C75,38.1,74.5,38.3,74,38.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guide_Boxes",
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 11.1,
    className: "st3",
    width: 87.2,
    height: 86.8
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPediatricAllergist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pediatric_allergist.e41ba03f.svg";
export { ForwardRef as ReactComponent };